import React from 'react';
import { motion } from 'framer-motion';
import { PawPrint } from './PawPrint';
export function Method() {
  return <section className="py-14 md:py-24 px-4 bg-amber text-white relative overflow-hidden" data-id="element-103">
      <PawPrint className="absolute top-0 right-10 w-32 h-32 text-white/10 rotate-45" data-id="element-104" />
      <PawPrint className="absolute bottom-10 left-10 w-24 h-24 text-white/10 -rotate-12" data-id="element-105" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-107">
          <h2 className="text-4xl md:text-5xl mb-8 text-white" data-id="element-108">
            Presentamos el Método E.A.B.C
          </h2>
          <p className="text-xl md:text-2xl font-bold mb-8 text-white/90" data-id="element-109">
            (Enriquecimiento Ambiental de Bajo Costo)
          </p>

          <div className="bg-white/10 backdrop-blur-sm p-8 md:p-10 rounded-3xl border border-white/20 text-left" data-id="element-110">
            <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-111">
              No necesitás ser arquitecto ni tener una cuenta bancaria abultada.
              Aprendé a usar la <strong data-id="element-112">"Verticalidad"</strong> y elementos
              cotidianos (como cajas de fiambrería, sogas de ferretería y
              muebles que ya tenés) para que tu gato gaste su energía ahí y no
              en tus cosas.
            </p>
            <p className="text-xl md:text-2xl font-heading text-center mt-8" data-id="element-113">
              En 7 días, tu gato va a estar más tranquilo, más flaco y tu sillón
              va a estar a salvo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}